import { render, staticRenderFns } from "./Proxycen.vue?vue&type=template&id=0eb88f8a&scoped=true&"
import script from "./Proxycen.vue?vue&type=script&lang=js&"
export * from "./Proxycen.vue?vue&type=script&lang=js&"
import style0 from "./Proxycen.vue?vue&type=style&index=0&id=0eb88f8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb88f8a",
  null
  
)

export default component.exports